var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,8h-6.0540161C23.2183838,6.9371948,24,5.5375366,24,4c0-2.2060547-1.7939453-4-4-4 c-1.6746826,0-3.1029663,1.34198-4,3.4840698C15.1029663,1.34198,13.6746826,0,12,0C9.7939453,0,8,1.7939453,8,4 c0,1.5375366,0.7816162,2.9371948,2.0540161,4H4c-1.1025391,0-2,0.8974609-2,2v4c0,1.1025391,0.8974609,2,2,2v14 c0,1.1025391,0.8974609,2,2,2h20c1.1025391,0,2-0.8974609,2-2V16c1.1025391,0,2-0.8974609,2-2v-4C30,8.8974609,29.1025391,8,28,8z  M13,30H6V16h7V30z M13,14H4v-4h9V14z M10,4c0-1.1025391,0.8974609-2,2-2c1.2880859,0,2.7138672,2.4755859,2.9619141,5.9375 C12.1835938,7.5986328,10,5.9326172,10,4z M17,30h-2V10h2V30z M17.0380859,7.9375C17.2861328,4.4755859,18.7119141,2,20,2 c1.1025391,0,2,0.8974609,2,2C22,5.9326172,19.8164062,7.5986328,17.0380859,7.9375z M19,30V16h7l0.0019531,14H19z M19,14v-4h9 l0.0019531,4H19z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSmall);
export default __webpack_public_path__ + "static/media/gift--small.84422c82cf1cccf0b23d0767b681f20f.svg";
export { ForwardRef as ReactComponent };